import { put } from 'redux-saga/effects';

import axios from '../../api/axios-msdo';
import * as actions from '../actions/index';
import { URL_CONFIG } from '../../shared/config/index';
import { SiteSessionStorage } from '../../shared/classes/index';

export function* getSitesSaga(action) {
    yield put(actions.getSitesStart());
    try {
        const res = yield axios.get(URL_CONFIG.getSiteListApi);
        if (res && res.data && res.data.statusCode === 200) {
            const siteSessionStorage = new SiteSessionStorage();
            const favorites = yield siteSessionStorage.favorites;
            const selectedSite = yield siteSessionStorage.selectedSite;
            let sites = res['data']['siteList'];

            //setting favorite to matching site
            if (favorites !== null && favorites.length) {
                favorites.forEach(favoriteId => {
                    sites.forEach(site => {
                        if (site.id === favoriteId) {
                            site['favorite'] = true;
                        }
                    })
                });
            }
            
            yield put(actions.getSitesSuccess({ sites: [...sites] }));
            yield put(actions.setSelectedSuccess(selectedSite));
        } else {
            throw (res.data ? res.data : res);
        }
    } catch (err) {
        yield put(actions.getSitesFail(err.message));
    }
}

export function* setFavoriteSiteSaga(action) {
    const siteSessionStorage = new SiteSessionStorage();
    let favorites = yield siteSessionStorage.favorites;
    if( favorites !== null && favorites.length && favorites.includes(action.siteId) ) {
        favorites = favorites.filter(item => item !== action.siteId);
    } else {
        favorites.push(action.siteId);
    }

    yield put(actions.setFavoriteStart());
    try {
        const res = yield axios.post(URL_CONFIG.favoriteSiteApi, favorites);
        if (res && res.data && res.data.statusCode === 200) {
            //finding and updating favorite site
            let updatedSites = [...action.sites];
            updatedSites.forEach(site => {
                if (site.id === action.siteId) {
                    site.favorite = !site.favorite;
                }
            });
            yield siteSessionStorage.setFavorites(favorites);
            yield put(actions.setFavoriteSuccess(updatedSites));
        } else {
            throw (res.data ? res.data : res);
        }
    } catch (err) {
        yield put(actions.setFavoriteFail(err.message));
    }
}

export function* setSiteSelectedSaga(action) {
    const siteSessionStorage = new SiteSessionStorage();
    let selectedSite = yield siteSessionStorage.selectedSite;

    if(selectedSite && selectedSite.id === action.site.id) {
        selectedSite = {};
    } else {
        selectedSite = action.site;
    }

    yield put(actions.setSelectedStart());
    try {
        const res = yield axios.post(URL_CONFIG.selectedSiteApi, selectedSite);
        if (res && res.data && res.data.statusCode === 200) {
            yield siteSessionStorage.setSelectedSite(selectedSite);
            yield put(actions.setSelectedSuccess(selectedSite));
        } else {
            throw (res.data ? res.data : res);
        }
    } catch (err) {
        yield put(actions.setSelectedFail(err.message));
    }
}

export function* getSiteDataSaga(action) {
    yield put(actions.getSiteDataStart());
    try {
        const res = yield axios.get(URL_CONFIG.getSiteApi, { headers: { siteid: action.siteId } });
        if (res && res.data && res.data.statusCode === 200) {
            let labors = Array.isArray(res['data']['data']['currentLabor']) ? res['data']['data']['currentLabor'] : [];
            let units = Array.isArray(res['data']['data']['unitAval']) ? res['data']['data']['unitAval'] : [];
            let events = Array.isArray(res['data']['data']['csiEvents']) ? res['data']['data']['csiEvents'] : [];
            yield put(actions.getSiteDataSuccess({ labors: labors, units: units, events: events }));
        } else {
            throw (res.data ? res.data : res);
        }
    } catch (err) {
        yield put(actions.getSiteDataFail(err.message));
    }
}

export function* getOOSUnitsSaga(action) {
    yield put(actions.getOOSUnitsStart());
    try {
        const res = yield axios.get(URL_CONFIG.getSiteLOB, { headers: { siteid: action.siteId, lob: action.lob } });
        if (res && res.data && res.data.statusCode === 200) {
            let units = [...action.units];
            units[action.unitIndex] = {
                ...units[action.unitIndex],
                services: res['data']['data']['oos_units']
            }
            yield put(actions.getOOSUnitsSuccess(units));
        } else {
            throw (res.data ? res.data : res);
        }
    } catch (err) {
        yield put(actions.getOOSUnitsFail(err.message));
    }
}